(() => {
  if (window.kennasMoastCartBridgeLoaded) return;
  window.kennasMoastCartBridgeLoaded = true;
  document.addEventListener('moast-cart-add', () => {
    if (typeof window.refreshCart === 'function') window.refreshCart(false);
  });
})();

(() => {
  'use strict';
  const marker = document.getElementById('kennas-stock-price-config');
  if (!marker) return;
  let config;
  try { config = JSON.parse(marker.textContent); } catch (_) { return; }
  window.kennasInStockCardPrices?.destroy();
  const selector = '.product-item[id^="product-item-"], moast-product';
  const moastWidgetIds = new Set(['6181a7ee-14a5-4f5f-aecf-73f212a36ca0']);
  const moastContainers = 'moast-carousel, moast-floating, moast-player, moast-products, moast-products-slideshow, moast-product';
  const moastRoots = new Map();
  const moastPending = new WeakSet();
  const cards = new Map();
  const products = new Map();
  const queue = new Set();
  const abort = new AbortController();
  const ttl = 60000;
  let busy = false;
  let stopped = false;
  let timer;

  function money(amount) {
    const pattern = new RegExp('\\x7B\\x7B\\s*(\\w+)\\s*\\x7D\\x7D', 'g');
    const formats = {
      amount: [2, ',', '.'],
      amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','],
      amount_no_decimals_with_comma_separator: [0, '.', ','],
      amount_with_apostrophe_separator: [2, "'", '.'],
      amount_with_space_separator: [2, ' ', ','],
      amount_no_decimals_with_space_separator: [0, ' ', ','],
      amount_with_period_and_space_separator: [2, ' ', '.']
    };
    let valid = false;
    const result = config.moneyFormat.replace(pattern, (token, name) => {
      const format = formats[name];
      if (!format) return token;
      valid = true;
      const parts = Number(amount).toFixed(format[0]).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, format[1]);
      return parts.join(format[2]);
    });
    if (!valid) return null;
    return new DOMParser().parseFromString(result, 'text/html').body.textContent;
  }

  function contextMatches() {
    return /^[A-Z]{2}$/.test(config.country) && /^[A-Z]{3}$/.test(config.currency) &&
      (!window.Shopify?.country || window.Shopify.country === config.country) &&
      (!window.Shopify?.currency?.active || window.Shopify.currency.active === config.currency);
  }

  function restoreNative(state) {
    if (state.applied !== null && state.value.textContent === state.applied) state.value.textContent = state.original;
    state.applied = null;
    delete state.card.dataset.kennasInStockPrice;
    delete state.card.dataset.kennasInStockVariant;
  }

  function readCard(card) {
    if (card.localName === 'moast-product') return readMoastCard(card);
    if (card.closest('#kennas-moast-home, moast-carousel, moast-floating')) return null;
    if (card.querySelector('.product-item__badge--sold')) return null;
    const original = card.querySelector('.product-item__price .product-price--original');
    const value = original?.querySelector('.money');
    const priceRoot = original?.closest('.product-price');
    const id = card.id.match(/^product-item-(\d+)$/)?.[1];
    if (!id || !original || !priceRoot) return null;
    if (!value) {
      if (priceRoot.children.length !== 1 || !/^[A-Z]{3}$/.test(config.currency)) return null;
      const textNodes = Array.from(original.childNodes).filter(node => node.nodeType === 3 && node.textContent.trim());
      if (textNodes.length !== 1) return null;
      const text = textNodes[0];
      const match = text.textContent.match(/^(\s*From\s+)([^\r\n]*?\d[^\r\n]*?)(\s+[A-Z]{3}\s*)$/);
      if (!match || match[3].trim() !== config.currency) return null;
      return { id, value: text, prefix: match[1], suffix: match[3] };
    }
    if (priceRoot.querySelectorAll('.money').length !== 1) return null;
    let hasPrefix = false;
    for (const node of original.childNodes) {
      if (node === value || node.contains?.(value)) break;
      if (node.nodeType === 3 && node.textContent.trim()) hasPrefix = true;
    }
    return hasPrefix ? { id, value } : null;
  }

  function ownsMoast(element) {
    for (let node = element; node; node = node.parentElement || node.getRootNode()?.host) {
      if (node.localName === 'moast-carousel') return moastWidgetIds.has(node.getAttribute('widget'));
      if (node.localName === 'moast-floating' || node.localName === 'moast-player') return moastWidgetIds.has(node.blockId) || moastWidgetIds.has(node.getAttribute('block-id'));
    }
    return false;
  }

  function readMoastCard(card) {
    if (!ownsMoast(card) || card.variant || card.link) return null;
    const id = String(card.product?.id || '').match(/^(?:gid:\/\/shopify\/Product\/)?(\d+)$/)?.[1];
    const value = card.shadowRoot?.querySelector('.product__price');
    if (!id || !value || !value.querySelector('.product__price-regular')) return null;
    return { id, value, kind: 'moast' };
  }

  function restoreMoast(state, release = false) {
    if (release) { state.waitStyle?.remove(); state.waitStyle = null; }
    state.label?.remove();
    state.style?.remove();
    state.label = null;
    state.style = null;
    delete state.card.dataset.kennasMoastStockPrice;
    delete state.card.dataset.kennasInStockPrice;
    delete state.card.dataset.kennasInStockVariant;
    delete state.card.dataset.kennasInStockMaxPrice;
    delete state.card.dataset.kennasInStockMaxVariant;
  }

  function applyMoast(state, product) {
    const current = readMoastCard(state.card);
    if (!current || current.id !== state.id || current.value !== state.value) {
      restoreMoast(state, true);
      return;
    }
    if (!contextMatches() || product.status === 'error') { restoreMoast(state); return; }
    if (product.status !== 'done' || !product.rangeComplete) return;
    if (!product.best) { restoreMoast(state); return; }
    if (product.best.currency !== config.currency || product.highest?.currency !== config.currency) { restoreMoast(state); return; }
    const formatted = money(product.best.amount);
    const maximum = money(product.highest.amount);
    if (formatted === null || maximum === null) return;
    if (!state.style?.isConnected) {
      state.style = document.createElement('style');
      state.style.dataset.kennasMoastPriceStyle = '';
      state.style.textContent = ':host([data-kennas-moast-stock-price]) .product__price > :not(.kennas-moast-stock-price) { display: none !important; }';
      state.card.shadowRoot.append(state.style);
    }
    if (!state.label || state.label.parentElement !== state.value) {
      state.label?.remove();
      state.label = document.createElement('span');
      state.label.className = 'kennas-moast-stock-price';
      state.value.append(state.label);
    }
    const text = `From ${formatted}`;
    if (state.label.textContent !== text) state.label.textContent = text;
    state.card.dataset.kennasMoastStockPrice = '';
    state.card.dataset.kennasInStockPrice = product.best.amount;
    state.card.dataset.kennasInStockVariant = product.best.id;
    state.card.dataset.kennasInStockMaxPrice = product.highest.amount;
    state.card.dataset.kennasInStockMaxVariant = product.highest.id;
  }

  function apply(state, product) {
    if (state.kind === 'moast') {
      if (state.card.isConnected) applyMoast(state, product);
      return;
    }
    if (!state.card.isConnected || !state.card.contains(state.value)) return;
    const current = readCard(state.card);
    if (!current || current.id !== state.id || current.value !== state.value ||
        !contextMatches() || product.status === 'error') { restoreNative(state); return; }
    if (product.status !== 'done') return;
    if (!product.best || product.best.currency !== config.currency) { restoreNative(state); return; }
    const formatted = money(product.best.amount);
    if (formatted === null) return;
    const display = (state.prefix || '') + formatted + (state.suffix || '');
    if (state.value.textContent !== display) state.value.textContent = display;
    state.applied = display;
    state.card.dataset.kennasInStockPrice = product.best.amount;
    state.card.dataset.kennasInStockVariant = product.best.id;
  }

  function schedule() {
    if (stopped || busy || timer || !queue.size) return;
    timer = setTimeout(() => { timer = null; run(); }, 40);
  }

  function request(state) {
    state.near = true;
    if (!contextMatches()) {
      if (state.kind === 'moast') restoreMoast(state, true);
      else restoreNative(state);
      return;
    }
    let product = products.get(state.id);
    if (product && (product.status === 'pending' || Date.now() - product.at < ttl)) {
      if (state.kind === 'moast') {
        product.needsRange = true;
        if (product.status === 'done' && !product.rangeComplete) {
          if (!product.cursor || product.pages >= 20) product.status = 'error';
          else {
            product.status = 'pending';
            queue.add(state.id);
            schedule();
          }
        }
      }
      apply(state, product);
      return;
    }
    product = {
      status: 'pending', at: Date.now(), cursor: null, best: null, highest: null,
      pages: 0, rangeComplete: false, needsRange: state.kind === 'moast'
    };
    products.set(state.id, product);
    queue.add(state.id);
    schedule();
  }

  async function run() {
    if (stopped || busy || !queue.size) return;
    busy = true;
    const ids = [...queue].slice(0, 6);
    ids.forEach(id => queue.delete(id));
    const fields = ids.map((id, i) => {
      const cursor = products.get(id).cursor;
      return `p${i}: product(id: "gid://shopify/Product/${id}") {
        id availableForSale
        priceRange { minVariantPrice { amount currencyCode } }
        variants(first: 250, sortKey: ID, after: ${JSON.stringify(cursor)}) {
          nodes { id availableForSale currentlyNotInStock price { amount currencyCode } }
          pageInfo { hasNextPage endCursor }
        }
      }`;
    }).join('\n');
    const timeout = new AbortController();
    const cancel = () => timeout.abort();
    abort.signal.addEventListener('abort', cancel, { once: true });
    const deadline = setTimeout(cancel, 8000);
    try {
      const response = await fetch('/api/2026-07/graphql.json', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          query: `query KennasCardPrices($country: CountryCode!) @inContext(country: $country) { ${fields} }`,
          variables: { country: config.country }
        }),
        signal: timeout.signal
      });
      if (!response.ok) throw new Error('Stock-price lookup failed');
      const result = await response.json();
      if (result.errors?.length || !result.data) throw new Error('Stock-price data unavailable');
      if (stopped) return;
      ids.forEach((id, i) => {
        const product = products.get(id);
        const data = result.data[`p${i}`];
        if (!data || data.id !== `gid://shopify/Product/${id}`) {
          product.status = 'error';
          product.at = Date.now();
          return;
        }
        if (!data.availableForSale) {
          product.best = null;
          product.highest = null;
          product.rangeComplete = true;
          product.status = 'done';
          product.at = Date.now();
          for (const state of cards.values()) if (state.id === id) apply(state, product);
          return;
        }
        for (const variant of data.variants.nodes) {
          if (!variant.availableForSale || variant.currentlyNotInStock) continue;
          if (variant.price.currencyCode !== config.currency) continue;
          const amount = Number(variant.price.amount);
          if (!Number.isFinite(amount) || amount < 0) continue;
          if (!product.best || amount < Number(product.best.amount)) {
            product.best = { id: variant.id, amount: variant.price.amount, currency: variant.price.currencyCode };
          }
          if (!product.highest || amount > Number(product.highest.amount)) {
            product.highest = { id: variant.id, amount: variant.price.amount, currency: variant.price.currencyCode };
          }
        }
        const page = data.variants.pageInfo;
        const minimum = data.priceRange.minVariantPrice;
        const atAbsoluteMinimum = product.best && minimum.currencyCode === config.currency &&
          Number(product.best.amount) === Number(minimum.amount);
        product.pages += 1;
        product.rangeComplete = !page.hasNextPage;
        if (page.hasNextPage && (product.needsRange || !atAbsoluteMinimum)) {
          if (!page.endCursor || page.endCursor === product.cursor || product.pages >= 20) {
            product.status = 'error';
            product.at = Date.now();
            return;
          }
          product.cursor = page.endCursor;
          queue.add(id);
        } else {
          product.cursor = page.hasNextPage ? page.endCursor : null;
          product.status = 'done';
          product.at = Date.now();
          for (const state of cards.values()) if (state.id === id) apply(state, product);
        }
      });
    } catch (error) {
      if (!stopped) {
        ids.forEach(id => {
          const product = products.get(id);
          product.status = 'error';
          product.at = Date.now();
        });
        console.warn('[Kenna’s in-stock card prices] Original prices retained; lookup unavailable.');
      }
    } finally {
      clearTimeout(deadline);
      abort.signal.removeEventListener('abort', cancel);
      busy = false;
      if (!stopped) for (const state of cards.values()) {
        if (ids.includes(state.id) && products.get(state.id)?.status === 'error') apply(state, products.get(state.id));
      }
      schedule();
    }
  }

  const visibility = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      const state = cards.get(entry.target);
      if (!state) continue;
      state.near = entry.isIntersecting;
      if (state.near) request(state);
    }
  }, { rootMargin: '500px' }) : null;

  function discover(card) {
    const info = readCard(card);
    const old = cards.get(card);
    if (!info) {
      if (old) {
        if (old.kind === 'moast') restoreMoast(old, true);
        else restoreNative(old);
        visibility?.unobserve(card);
        cards.delete(card);
      }
      return;
    }
    if (old?.value === info.value && old.id === info.id) {
      const product = products.get(info.id);
      if (product) apply(old, product);
      return;
    }
    if (old?.kind === 'moast') restoreMoast(old, true);
    const state = { card, ...info, original: info.value.textContent, applied: null, near: false };
    if (state.kind === 'moast') {
      state.waitStyle = document.createElement('style');
      state.waitStyle.dataset.kennasMoastAwaitPrice = '';
      state.waitStyle.textContent = ':host(:not([data-kennas-moast-stock-price])) .product__price { visibility: hidden; }';
      card.shadowRoot.append(state.waitStyle);
    }
    cards.set(card, state);
    if (state.kind !== 'moast') request(state);
    else if (visibility) visibility.observe(card);
    else request(state);
  }

  function scan(root) {
    if (stopped) return;
    if (root.matches?.(selector)) discover(root);
    root.querySelectorAll?.(selector).forEach(discover);
    if (root.matches?.(moastContainers)) inspectMoast(root);
    root.querySelectorAll?.(moastContainers).forEach(inspectMoast);
  }

  function inspectMoast(element) {
    if (stopped || moastRoots.has(element) || moastPending.has(element)) return;
    moastPending.add(element);
    customElements.whenDefined(element.localName).then(() => element.updateComplete).then(() => {
      moastPending.delete(element);
      if (stopped || !element.isConnected || !element.shadowRoot || !ownsMoast(element)) return;
      if (moastRoots.has(element)) return;
      const observer = new MutationObserver(onChanges);
      moastRoots.set(element, observer);
      observer.observe(element.shadowRoot, { childList: true, subtree: true, characterData: true });
      if (element.localName === 'moast-product') discover(element);
      scan(element.shadowRoot);
    }).catch(() => moastPending.delete(element));
  }

  function onChanges(records) {
    if (stopped) return;
    for (const record of records) {
      const host = record.target.getRootNode()?.host;
      const owner = host?.localName === 'moast-product' ? host :
        record.target.nodeType === 1 ? record.target.closest(selector) : null;
      if (owner) discover(owner);
      record.addedNodes.forEach(node => { if (node.nodeType === 1) scan(node); });
    }
    for (const [card] of cards) {
      if (!card.isConnected) {
        const state = cards.get(card);
        if (state.kind === 'moast') restoreMoast(state, true);
        visibility?.unobserve(card);
        cards.delete(card);
      }
    }
    for (const [element, observer] of moastRoots) {
      if (!element.isConnected) {
        observer.disconnect();
        moastRoots.delete(element);
      }
    }
  }
  const changes = new MutationObserver(onChanges);

  function refresh() {
    if (document.hidden || stopped) return;
    for (const state of cards.values()) if (state.near) request(state);
  }

  function destroy() {
    stopped = true;
    clearTimeout(timer);
    abort.abort();
    changes.disconnect();
    visibility?.disconnect();
    moastRoots.forEach(observer => observer.disconnect());
    moastRoots.clear();
    for (const state of cards.values()) {
      if (state.kind === 'moast') { restoreMoast(state, true); continue; }
      if (state.applied !== null && state.value.textContent === state.applied) state.value.textContent = state.original;
      delete state.card.dataset.kennasInStockPrice;
      delete state.card.dataset.kennasInStockVariant;
    }
    cards.clear();
    products.clear();
    queue.clear();
  }

  function label(card) {
    if (!card || !ownsMoast(card) || !contextMatches() || card.link) return '';
    if (card.variant) {
      const text = card.shadowRoot?.querySelector('.product__price-regular')?.textContent.trim();
      return text ? `From ${text}` : '';
    }
    discover(card);
    const state = cards.get(card);
    if (!state) return '';
    request(state);
    return contextMatches() ? state.label?.textContent || '' : '';
  }
  window.kennasInStockCardPrices = { scan, label, destroy };
  changes.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', event => scan(event.target), { signal: abort.signal });
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.contains(marker)) destroy();
  }, { signal: abort.signal });
  document.addEventListener('visibilitychange', refresh, { signal: abort.signal });
  window.addEventListener('focus', refresh, { signal: abort.signal });
  window.addEventListener('pageshow', refresh, { signal: abort.signal });
  scan(document);
})();
